
class PrestupyUtils {

    public static Stav_PotvrzeniIC = 0;          // 0 - ceka se na potvrzeni IC 
    public static Stav_ZaplaceniPopl = 1;        // 1 - ceka se na zaplaceni popl. za prestup 
    public static Stav_ZpracovaniPrestupu = 11;  // 11 - ceka se na zapracovani prestupu sekretariatem
    public static Stav_PotvrzeniOdst = 101;      // 101 - ceka se na uplatneni naroku na odstupneho puv. KC
    public static Stav_ZaplaceniOdst = 102;      // 102 - ceka se na potvrzeni puv. KC o zaplaceni odstupneho
    public static Stav_Ukonceno = 1001;          // 1001 - prestup uzavren
    public static Stav_ZamitnutoIC = 1801;       // 1801 - prestup zamitnut indiv. clenem
    public static Stav_Stornovan = 1901;         // 1901 - prestup stornovan

    public static TypZpravy_PorizeniPrestupu = 1;
    public static TypZpravy_PotvrzeniIC = 2;
    public static TypZpravy_ProvedeniPrestupu = 3;
    public static TypZpravy_PotvrzeniOdst = 4;
    public static TypZpravy_ZaplaceniOdst = 5;
    public static TypZpravy_ZaplaceniSP = 6;
    public static TypZpravy_Stornovan = 7;

}

export default PrestupyUtils;